export default __webpack_public_path__ + "static/media/car.105d96d8.svg";